/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Provider_CustomInputs */

const en_byoa_provider_custom = /** @type {(inputs: Byoa_Provider_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const id_byoa_provider_custom = /** @type {(inputs: Byoa_Provider_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lainnya`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Byoa_Provider_CustomInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_provider_custom = /** @type {((inputs?: Byoa_Provider_CustomInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Provider_CustomInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_provider_custom(inputs)
	return en_byoa_provider_custom(inputs)
});